if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    if ( submitButton ){
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
    } 
    

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        return Shopify.getCart(function(cart) {
          trigger('productAddToCart', document, { product: parsedState, list: this.dataset.list })
        }.bind(this))
      })
      .then((state) => {
        return fetch("/?sections=cart-drawer,cart-icon-bubble")
        .then((response) => {return response.json() })
        .then((responseText) => {
          const html = responseText
          const replaceDrawer =
            document.getElementById('cart-drawer__content').querySelector('cart-drawer__content') || document.getElementById('cart-drawer__content');
          const replaceBubble =
            document.getElementById('cart-icon-bubble').querySelector('.shopify-section') || document.getElementById('cart-icon-bubble');

          replaceDrawer.innerHTML =
            getSectionInnerHTML(html['cart-drawer'], '.cart-drawer__content');  
          replaceBubble.innerHTML =
            getSectionInnerHTML(html['cart-icon-bubble'], '.shopify-section');    
            
            var api = new Yotpo.API(yotpo);
            api.refreshWidgets();
            MicroModal.init();
        })
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
    	var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});


// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cartNotification = document.querySelector('cart-notification');
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       const submitButton = this.querySelector('[type="submit"]');
//       if (submitButton.classList.contains('loading')) return;

//       this.handleErrorMessage();
//       this.cartNotification.setActiveElement(document.activeElement);

//       submitButton.setAttribute('aria-disabled', true);
//       submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);
//       formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
//       formData.append('sections_url', window.location.pathname);
//       config.body = formData;

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           this.cartNotification.renderContents(response);
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           submitButton.classList.remove('loading');
//           submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }

class SubscriptionSelection extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onSubscriptionChange);
    this.addEventListener('click', this.onSubscriptionClick);
  }


  onSubscriptionClick(event){
    if (event.target.closest('.subscription-pdp')) {
      event.target.closest('.subscription-pdp').classList.remove('is-open')
      event.target.closest('.subscription-pdp').setAttribute('aria-hidden', true)
      event.target.closest('.product-form__subscription-options-trigger').classList.remove('active')
    }
    const subscription_id = event.target.closest('label[data-product-id]') && event.target.closest('label[data-product-id]').querySelector('input:checked');
    if(subscription_id){
      event.target.closest("label[data-product-id]").classList.add("is-active");
    } else {
      this.querySelector("label[data-product-id].is-active") && this.querySelector("label[data-product-id].is-active").classList.remove("is-active");
    }
  }

  onSubscriptionChange(event){
    console.log('changing');
    const attributes = JSON.parse(event.target.value);
    const formID = event.target.getAttribute('form');
    const target = event.target;
    console.log("target: ", target);
    const popup = target.closest(".subscription-modal");
    const price = popup.querySelector(".price-container");

    // price.innerText = target.dataset.price;

    // if(this.querySelector(".subscription-option__wrapper.active")){
    //   this.querySelector(".subscription-option__wrapper.active").classList.remove("active");
    //   event.target.closest(".subscription-option__wrapper").classList.add("active");
    // }
    const form_notice = document.querySelector(`.subscription-product-form__notice[product_form_id="${formID}"]`);
    
    if (form_notice){
      const data_three_month = form_notice.getAttribute('data-three-month')
      const data_three_month_content = form_notice.getAttribute('data-three-month-content')
      const data_six_month = form_notice.getAttribute('data-six-month')
      const data_six_month_content = form_notice.getAttribute('data-six-month-content')
      let noticeContent = form_notice.querySelector("[data-notice-content]");
  
      if (attributes.id == data_three_month) {
        form_notice.style.display = "flex"
        noticeContent.innerHTML = data_three_month_content
      } else if (attributes.id == data_six_month) {
        form_notice.style.display = "flex"
        noticeContent.innerHTML = data_six_month_content
      } else {
        form_notice.style.display = "none"
        noticeContent.innerHTML = ''
      }

    }

    // update subscription display
    if( document.querySelector("subscription-display") ){
      this.setAttributes(document.querySelector("subscription-display"), attributes)
    }
    
    // update subscribe buttons
    const subscribe_buttons = document.querySelectorAll(`[data-section='${this.dataset.section}'][data-subscribe-button]`)
    if( !subscribe_buttons ) return;
    subscribe_buttons.forEach( button => {
      button.querySelector('[data-product-price]').innerText = attributes.price

      if( button.querySelector('[data-button-title]') ){
        button.querySelector('[data-button-title]').innerHTML = attributes.button_title
      }

      if( button.hasAttribute('data-subscribe-submit') ){
        button.setAttribute("data-subscribe-product", attributes.id );
      }
      if( button.hasAttribute('data-subscribe-submit-pdp') ){
        button.setAttribute("data-subscribe-product", attributes.id );
      }
    })

    console.log('complete');
  }

  setAttributes(element, attributes) {
    Object.keys(attributes).forEach(attr => {
      element.setAttribute(attr, attributes[attr]);
    });
  }
}

customElements.define('subscription-selection', SubscriptionSelection);

class SubscriptionDisplay extends HTMLElement {

  static get observedAttributes() {
    return ["title", "price", "current_price", "discount", "description"];
  }

  constructor(){
    super();

    let template = document.getElementById("subscriptionDisplay");
    let templateContent = template.content;
    


    this.attachShadow({mode: "open"});
    this.shadowRoot.append(templateContent.cloneNode(true));
    
    let subscriptionTitle = this.shadowRoot.querySelector("[data-subscription-title]");
    let subscriptionPrice = this.shadowRoot.querySelector("[data-subscription-price]")
    let subscriptionCurrentPrice = this.shadowRoot.querySelector("[data-subscription-current-price]")
    let subscriptionDiscount = this.shadowRoot.querySelector("[data-subscription-discount]")
    let subscriptionDescription = this.shadowRoot.querySelector("[data-subscription-description]")

    subscriptionTitle.innerText = this.getAttribute("title");
    subscriptionPrice.innerText = this.getAttribute("price");
    subscriptionCurrentPrice.innerText = this.getAttribute("current-price");
    subscriptionDiscount.innerText = this.getAttribute("discount");
    subscriptionDescription.innerText = this.getAttribute("description");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let subscriptionTitle = this.shadowRoot.querySelector("[data-subscription-title]");
    let subscriptionPrice = this.shadowRoot.querySelector("[data-subscription-price]")
    let subscriptionCurrentPrice = this.shadowRoot.querySelector("[data-subscription-current-price]")
    let subscriptionDiscount = this.shadowRoot.querySelector("[data-subscription-discount]")
    let subscriptionDescription = this.shadowRoot.querySelector("[data-subscription-description]")

    subscriptionDiscount.textContent == '' ? subscriptionDiscount.style.display= "none" : subscriptionDiscount.style.display= "block"

    if (newValue !== oldValue) {
      switch (name) {
        case "title":
          subscriptionTitle.innerText = newValue;
          break;
        case "price":
          subscriptionPrice.innerText = newValue;
          break;
        case "current_price":
          subscriptionCurrentPrice.innerText = newValue;
          break;
        case "discount":
          subscriptionDiscount.innerText = newValue;
          break;
        case "description":
          subscriptionDescription.innerText = newValue;
          break;
      }
    }
  }
}

customElements.define('subscription-display', SubscriptionDisplay);

document.addEventListener("click", function(e){
  console.log('clicked');
  if(e.target && e.target.hasAttribute("data-subscribe-submit")){
    console.log('subscribe clicked');
    handleSubscribeSubmit(e)
  }
  if(e.target && e.target.hasAttribute("data-subscribe-submit-pdp")){
    handleSubscribeSubmitPDP(e)
  }
})
function handleSubscribeSubmit(evt){
    evt.preventDefault;
    console.log('subscribe event fired');

    let subscribeButton = evt.target;
      subscribeButton.setAttribute('disabled', true);
      subscribeButton.classList.add('loading');

    const subscription_id = JSON.parse(evt.target.closest("subscription-selection").querySelector(`[name='${subscribeButton.dataset.section}-subscription-frequency']:checked`).value).id;
    const form_to_submit = document.querySelector(`product-form[id='sub-${ subscription_id }']`);
    const variant_id = form_to_submit.querySelector('select[name="id"] option:checked').value;
    const list = subscribeButton.dataset.list
    const selling_plan = form_to_submit.querySelector('[name=selling_plan]') && form_to_submit.querySelector('[name=selling_plan]').value;
    
    const body = JSON.stringify({
      items: [{
        id: variant_id,
        quantity: 1,
        ...(selling_plan && { selling_plan })
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
      return Shopify.getCart(function(cart) {
        trigger('productAddToCart', document, { product: parsedState, list })
      }.bind(this))
    })
    .then((state) => {
      return fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then((response) => {return response.json() })
      .then((responseText) => {
        const html = responseText
        const replaceDrawer =
          document.getElementById('cart-drawer__content').querySelector('cart-drawer__content') || document.getElementById('cart-drawer__content');
        const replaceBubble =
          document.getElementById('cart-icon-bubble').querySelector('.shopify-section') || document.getElementById('cart-icon-bubble');

          replaceDrawer.innerHTML =
            getSectionInnerHTML(html['cart-drawer'], '.cart-drawer__content');  
          replaceBubble.innerHTML =
            getSectionInnerHTML(html['cart-icon-bubble'], '.shopify-section');    
            
            var api = new Yotpo.API(yotpo);
            api.refreshWidgets();
            MicroModal.init();
        })
      })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          subscribeButton.classList.remove('loading');
          subscribeButton.removeAttribute('disabled');
          MicroModal.close(subscribeButton.closest(".subscription-modal").id);
          document.querySelector('cart-drawer').open();
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
        });

}

function handleSubscribeSubmitPDP(evt){
  evt.preventDefault;
  console.log('subscribe PDP event fired');

  let subscribeButton = evt.target;
    subscribeButton.setAttribute('disabled', true);
    subscribeButton.classList.add('loading');
    const subscription_id = JSON.parse(evt.target.closest("subscription-selections").querySelector('button[data-subscribe-product]').getAttribute('data-subscribe-product'));
    const form_to_submit = document.querySelector(`product-form[id='sub-${ subscription_id }']`);
    const variant_id = form_to_submit.querySelector('select[name="id"] option:checked').value;
    const list = subscribeButton.dataset.list
    const selling_plan = form_to_submit.querySelector('[name=selling_plan]') && form_to_submit.querySelector('[name=selling_plan]').value;    
    
    const body = JSON.stringify({
      items: [{
        id: variant_id,
        quantity: 1,
        ...(selling_plan && { selling_plan })
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
      return Shopify.getCart(function(cart) {
        trigger('productAddToCart', document, { product: parsedState, list })
      }.bind(this))
    })
    .then((state) => {
      return fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then((response) => {return response.json() })
      .then((responseText) => {
        const html = responseText
        const replaceDrawer =
          document.getElementById('cart-drawer__content').querySelector('cart-drawer__content') || document.getElementById('cart-drawer__content');
        const replaceBubble =
          document.getElementById('cart-icon-bubble').querySelector('.shopify-section') || document.getElementById('cart-icon-bubble');

        replaceDrawer.innerHTML =
          getSectionInnerHTML(html['cart-drawer'], '.cart-drawer__content');  
        replaceBubble.innerHTML =
          getSectionInnerHTML(html['cart-icon-bubble'], '.shopify-section');    
          
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
          MicroModal.init();
      })
    })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        subscribeButton.classList.remove('loading');
        subscribeButton.removeAttribute('disabled');
        document.querySelector('cart-drawer').open();
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
        document.querySelector('body').style.overflow = 'visible';
      });

}


console.log('running');

// PDP purchase type select

function updateSub(frequency){
  const form = document.querySelector('.subscription-pdp-modal');
  const labels = form.querySelectorAll('.radio-label');
  const subLabel = document.querySelector(".subscription-frequency");
  const currentPrice = document.querySelector(".active-price");
  const currentCompare = document.querySelector(".active-compare");
  const deliveryFrequency =  document.querySelector(".product-form__info-delivery");

  labels.forEach(label => {
    console.log(label);
    if (label.dataset.productId == frequency.dataset.id){
      label.click();
    }
  });

  subLabel.innerHTML = frequency.dataset.value;
  currentPrice.innerHTML = frequency.dataset.price;
  currentCompare.innerHTML = frequency.dataset.compareAtPrice;
  deliveryFrequency.innerHTML = frequency.dataset.deliveryFrequency;
}

function changeToSub(){
  const sub = document.querySelector(".product-form__subscription");
  const oneoff = document.querySelector(".product-form__oneoff-trigger");
  sub.classList.add('active');
  oneoff.classList.remove('active');
}

function changeToOneoff(){
  const form = document.querySelector('.subscription-pdp-modal');
  const labels = form.querySelectorAll('.radio-label');

  
  const sub = document.querySelector(".product-form__subscription");
  const oneoff = document.querySelector(".product-form__oneoff-trigger");
  sub.classList.remove('active');
  oneoff.classList.add('active');
  
  labels.forEach(label => {
    console.log(label);
    if (label.classList.contains('one-time')){
      label.click();
    }
  });
}

const oneoff = document.querySelector(".product-form__oneoff-trigger");

if (oneoff){
  oneoff.addEventListener('click', this.changeToOneoff);
}

const sub = document.querySelector(".product-form__subscription-trigger");

if (sub){
  sub.addEventListener('click', this.changeToSub);
}

const frequencies = document.querySelectorAll(".product-form__frequency");
frequencies.forEach(frequency => {
  frequency.addEventListener("click", () => {
    this.updateSub(frequency);
  });
});

const toggle = document.querySelector(".subscription-frequency-toggle");
const content = document.querySelector(".product-form__frequencies");

if (toggle){
  toggle.addEventListener("click", () => {
    console.log('clicked');
    toggle.classList.toggle('active');
    content.classList.toggle('active');
  });
}

